<template>
  <jt-data-table
    ref="table"
    v-bind="$props"
    @update:selected="onSelectedUpdate"
  >
    <template :slot="buttons.length > 0 && !rowButtons ? 'top' : 'none'">
      <q-space />
      <div class="q-px-md q-pb-md q-gutter-sm full-width text-right">
        <q-btn
          v-for="(button, index) in buttons"
          :key="index"
          color="secondary"
          @click="actionButtonValidate(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </template>
    <template v-slot:header="{props}">
      <q-tr :props="{props}">
        <q-td v-if="!noneselect && !rowButtons" auto-width />
        <q-td v-for="col in props.cols" :key="col.name" :props="props">
          {{ col.label }}
        </q-td>
        <q-td style="width: 1px" v-if="buttons.length > 0 && rowButtons" />
      </q-tr>
    </template>
    <template v-slot:body="{ props }">
      <q-tr :props="{props}">
        <q-td v-if="!noneselect && !rowButtons" auto-width>
          <q-checkbox v-model="props.selected" color="primary" />
        </q-td>
        <q-td v-for="col in props.cols" :key="col.name" :props="props">
          <span v-if="!col.edit">
            {{ formatedValue(col) }}
          </span>
          <q-toggle
            v-else-if="col.type == 'CHECKBOX'"
            v-model="props.row[col.model]"
          />
          <span v-else>
            {{ props.row[col.model] }}
            <i class="fas fa-pencil-alt material-icons" />
            <q-popup-edit v-model="props.row[col.model]" auto-save>
              <jt-input
                v-model="props.row[col.model]"
                :type="col.type.toLowerCase()"
                :name="col.model"
              />
            </q-popup-edit>
          </span>
          <q-btn
            v-if="col.name === 'showhide'"
            flat
            round
            color="primary"
            class="q-mr-sm"
            :icon="props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            @click="props.expand = !props.expand"
          />
        </q-td>
        <q-td style="width: 1px" v-if="buttons.length > 0 && rowButtons">
          <span v-for="(button, index) in buttons" :key="index">
            <q-btn
              flat
              small
              class="protocol-close"
              color="primary"
              v-if="filterButton(button, props.row)"
              @click="actionButton(button, props.row)"
            >
              <q-icon :name="iconAction(button)" size="22px" />
              <q-tooltip>{{ button.label }}</q-tooltip>
            </q-btn>
          </span>
        </q-td>
      </q-tr>
      <q-tr v-show="props.expand" :props="props">
        <q-td colspan="100%">
          <div class="row hidden-row">
            <div v-for="(col, key) in hiddenColuns" :key="key" class="col-6">
              <label>{{ col.label }}:</label>
              {{ props.row[col.model] }}
            </div>
          </div>
        </q-td>
      </q-tr>
    </template>
  </jt-data-table>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDocs } from 'jtech-webcomps'

@Component({
  name: 'modalContractAdditive',
  mixins: [JtDataTable],
  components: { jtDocsViewer: JtDocs.JtDocsViewer },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
export default class ModalContractAdditive extends Vue {}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
